import { AdminClientReportPDF } from './AdminClientReportPDF';

export default AdminClientReportPDF;